<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-grid fullWidth>
      <cv-row>
        <cv-column :sm="4" :md="4" :lg="8">
          <data-valida etichetta="Dalla Data"
                       v-model="parametri.dalla_data"
                       messaggio_non_valido="Data iniziale non valida" />
        </cv-column>
        <cv-column :sm="4" :md="4" :lg="8">
          <data-valida etichetta="Alla Data"
                       v-model="parametri.alla_data"
                       messaggio_non_valido="Data finale non valida" />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="4" :lg="8">
          <data-valida etichetta="Data in Fattura"
                       v-model="parametri.data_in_fattura"
                       messaggio_non_valido="Data in fattura non valida" />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-combo-box label=""
                        title="Cliente" :auto-filter="true"
                        value=""
                        :options="clienti"></cv-combo-box>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-combo-box label=""
                        :auto-filter="true"
                        title="Coltura" value=""
                        :options="colture"></cv-combo-box>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-combo-box label=""
                        :auto-filter="true"
                        title="Fondo" value=""
                        :options="fondi"></cv-combo-box>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-button kind="primary"
                     @click="$emit('bottone-premuto')"
                     :icon="svg_fattura">Genera Fatture</cv-button>
        </cv-column>
      </cv-row>
    </cv-grid>
  </cv-content>
</template>

<script>
import DocumentIco from '@carbon/icons-vue/es/document/16';

export default {
  name: "GenerazioneFatturePerLavori",
  data: function() {
    return {
      parametri: {
        dalla_data: "",
        alla_data: "",
        data_in_fattura: ""
      },
      svg_fattura: DocumentIco,
      clienti: [
        {
          value: "1",
          label: "Azienda Agricola Mario Rossi s.r.l",
          name: "Azienda Agricola Mario Rossi s.r.l"
        },
        {
          value: "2",
          label: "Paolo Verdi s.r.l",
          name: "Paolo Verdi s.r.l"
        }
      ],
      colture: [
        {
          value: "1",
          label: "Barbabietole",
          name: "Barbabietole"
        },
        {
          value: "2",
          label: "Grano",
          name: "Grano"
        }
      ],
      fondi: [
        {
          value: "1",
          label: "Fusignano",
          name: "Fusignano"
        },
        {
          value: "2",
          label: "Russi",
          name: "Russi"
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>